import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {SvgIconDPC} from "../../index";

export default class DpcGalleryPhotoVideoContainer extends React.Component {
    constructor(props) {
        super(props);
        this.settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: Math.min(3, this.props.children.length),
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 768,
                settings: {
                  slidesToShow: 1
                }
            }]
        };
    }

    render() {
        return (
            <section className="container-fluid gallery-photo-video-embed">
                <div className="container">
                    <h3>{this.props.titoloSezione}</h3>
                </div>
                <div className="container-fluid gallery-bg-dark">
                    <div className="container">
                        <div className="px-custom">
                            {this.props.linkTorna &&
                            <p className="gallery-photo-video-embed-read-more">
                                <a className="read-more" href={this.props.linkTorna}>
                                    <span className="text">{(typeof window !== "undefined" && window.location.pathname.split("/")[1] === 'it') ? 'Vedi tutto' : 'Show more'}</span>
                                    <SvgIconDPC name={'arrow-right'}/>
                                </a>
                            </p>
                            }
                            <div className="it-carousel-wrapper">
                                <div className="it-carousel-all it-img-card">
                                    <Slider {...this.settings}>
                                        {this.props.children}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
